import { Icon, IconNames, IconSizes } from 'atoms/Icon'
import {
  TextBoxMaxLine1FontSmBold,
  TextBoxMaxLine1FontXs,
} from 'atoms/TextBox/Templates'
import { COLOR } from 'vars/color'
import {
  QualityMenuButtonSC,
  QualityMenuButtonTextSC,
} from './QualityMenuButton.styled'

interface IQualityMenuButtonProps {
  title: string
  description?: string
  onClick?: () => void
  selected?: boolean
}

export const QualityMenuButton = ({
  title,
  description,
  selected = true,
  onClick,
}: IQualityMenuButtonProps) => {
  return (
    <QualityMenuButtonSC onClick={onClick}>
      <QualityMenuButtonTextSC>
        <TextBoxMaxLine1FontSmBold title={title} />

        {description && <TextBoxMaxLine1FontXs title={description} />}
      </QualityMenuButtonTextSC>

      {selected && (
        <Icon
          name={IconNames.check}
          size={IconSizes.mSm}
          color={COLOR.ACCENT_SECONDARY}
        />
      )}
    </QualityMenuButtonSC>
  )
}
